if (document.body.classList.contains('template-index')) {
(() => {
  'use strict';

  function boot(scope = document) {
    scope.querySelectorAll('[data-pc-mix-guide]').forEach(root => {
      if (root.dataset.guideReady === 'true') return;
      root.dataset.guideReady = 'true';

      const machine = root.querySelector('[data-guide-machine]');
      const empty = root.querySelector('[data-guide-empty]');
      const progress = root.querySelector('[data-guide-progress]');
      const jump = root.querySelector('[data-guide-jump]');
      const outcome = root.querySelector('.pc-guide__outcome');
      const results = Array.from(root.querySelectorAll('[data-guide-result]'));
      if (!machine || !empty || !outcome) return;

      const formats = {
        auto: 'Pour votre machine automatique, sélectionnez le café en grains sur la fiche produit.',
        grinder: 'Avec votre moulin, ajustez la mouture selon votre préparation.',
        espresso: 'Pour votre porte-filtre, vérifiez la mouture espresso proposée sur la fiche.',
        filter: 'Pour votre cafetière filtre, sélectionnez une mouture adaptée au moment de commander.',
        press: 'Pour votre cafetière à piston, choisissez la mouture adaptée à cette préparation.',
        moka: 'Pour votre cafetière italienne, vérifiez la mouture proposée sur la fiche.'
      };

      function update() {
        const taste = root.querySelector('[data-guide-taste]:checked')?.value || '';
        const length = root.querySelector('[data-guide-length]:checked')?.value || '';
        const answered = Number(Boolean(machine.value)) + Number(Boolean(taste)) + Number(Boolean(length));
        let handle = '';

        if (machine.value && taste) {
          if (taste === 'unsure') handle = 'pack-decouverte';
          else if (taste === 'soft') handle = 'sol-andino-sierra-alta';
          else if (taste === 'balanced') handle = 'signature-tierra-suave';
          else if (taste === 'milk') handle = 'espresso-brasa-morena';
          else if (taste === 'strong') {
            const longCoffee = length === 'long' || (!length && ['filter', 'press'].includes(machine.value));
            handle = longCoffee ? 'patagonia-ouro-preto' : 'espresso-brasa-morena';
          }
        }

        if (handle && !results.some(result => result.dataset.guideResult === handle)) handle = '';
        empty.hidden = Boolean(handle);
        if (progress) progress.textContent = answered + ' / 3 choix renseignés';
        if (jump) jump.hidden = !handle;

        results.forEach(result => {
          const selected = result.dataset.guideResult === handle;
          result.hidden = !selected;
          if (selected) {
            const format = result.querySelector('[data-guide-format]');
            if (format) format.textContent = handle === 'pack-decouverte'
              ? 'Quatre cafés à comparer chez vous, selon les formats proposés dans le pack.'
              : (formats[machine.value] || '');
          }
        });
        root.querySelectorAll('[data-guide-step]').forEach(step => {
          const key = step.dataset.guideStep;
          const done = key === 'machine' ? Boolean(machine.value) : key === 'taste' ? Boolean(taste) : Boolean(length);
          step.classList.toggle('is-complete', done);
        });
      }

      root.addEventListener('change', event => {
        update();
        if (event.target.matches('[data-guide-length]') && window.matchMedia('(max-width: 749px)').matches) {
          const selected = results.find(result => !result.hidden);
          if (selected) outcome.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
        }
      });

      if (jump) jump.addEventListener('click', () => outcome.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'}));
      update();
    });
  }

  function openGuide() {
    if (location.hash !== '#trouver-mon-cafe') return;
    const guide = document.querySelector('[data-pc-mix-guide]');
    if (guide) guide.open = true;
  }

  document.addEventListener('click', event => {
    if (!event.target.closest('[data-pc-open-guide]')) return;
    const guide = document.querySelector('[data-pc-mix-guide]');
    if (guide) guide.open = true;
  });
  window.addEventListener('hashchange', openGuide);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {boot();openGuide();}, {once:true});
  } else {
    boot();
    openGuide();
  }
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();

} else {
/* Small additions to the 06-10 design. Product forms and order handling stay native. */
(()=>{'use strict';
  function boot(scope=document){
    scope.querySelectorAll('[data-pc-mix-guide]').forEach(root=>{
      if(root.dataset.mixReady)return;root.dataset.mixReady='true';
      const machine=root.querySelector('[data-mix-machine]'),taste=root.querySelector('[data-mix-taste]');
      const update=()=>{
        let handle='';
        if(machine.value&&taste.value){
          handle=({soft:'sol-andino-sierra-alta',balanced:'signature-tierra-suave',milk:'espresso-brasa-morena',unsure:'pack-decouverte'})[taste.value]||(['auto','espresso','moka'].includes(machine.value)?'espresso-brasa-morena':'patagonia-ouro-preto');
        }
        root.querySelector('[data-mix-empty]').hidden=Boolean(handle);
        root.querySelectorAll('[data-mix-result]').forEach(result=>{
          result.hidden=result.dataset.mixResult!==handle;
          if(!result.hidden)result.querySelector('[data-mix-format]').textContent=['auto','grinder'].includes(machine.value)?'Pour votre équipement : choisissez les grains sur la fiche.':'Choisissez les grains si vous avez un moulin, ou vérifiez la mouture adaptée à votre cafetière sur la fiche.';
        });
      };
      root.addEventListener('change',update);update();
    });
    scope.querySelectorAll('[data-pc-mix-favorite]').forEach(root=>{
      if(root.dataset.mixReady)return;root.dataset.mixReady='true';
      const select=root.querySelector('[data-mix-favorite]');
      select.addEventListener('change',()=>root.querySelectorAll('[data-mix-favorite-result]').forEach(result=>result.hidden=result.dataset.mixFavoriteResult!==select.value));
    });
  }
  function openGuide(){
    if(location.hash!=='#trouver-mon-cafe')return;
    const guide=document.querySelector('[data-pc-mix-guide]');if(guide)guide.open=true;
  }
  document.addEventListener('click',event=>{if(event.target.closest('[data-pc-open-guide]')){const guide=document.querySelector('[data-pc-mix-guide]');if(guide)guide.open=true;}});
  window.addEventListener('hashchange',openGuide);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{boot();openGuide();},{once:true});else {boot();openGuide();}
  document.addEventListener('shopify:section:load',e=>boot(e.target));
})();

}
